import type { FC, ReactNode } from 'react'

import { Phone, Plus } from 'lucide-react'
import { buttonStyles } from '@/lib/button-styles'
import { Container } from '@/components/generals/container'
import { SectionHeading } from '@/components/generals/section-heading'
import { business } from '@/constants/business'
import { FAQS } from '@/constants/content'

export const FaqSection: FC = (): ReactNode => {
    return (
        <section id='faq' aria-labelledby='faq-title' className='scroll-mt-20 bg-foam py-20 sm:py-28'>
            <Container className='grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16'>
                <div>
                    <SectionHeading
                        id='faq-title'
                        eyebrow='FAQ'
                        title='Questions, answered'
                        description="Can't see yours? Give us a call and we'll happily help."
                    />

                    <a href={business.phone.href} className={buttonStyles({ variant: 'dark', className: 'mt-8' })}>
                        <Phone className='size-4' />
                        {business.phone.display}
                    </a>
                </div>

                <div className='space-y-3'>
                    {FAQS.map(faq => (
                        <details
                            key={faq.question}
                            className='group rounded-2xl bg-card px-6 py-5 shadow-sm ring-1 ring-ink/5 transition-shadow open:shadow-md'
                        >
                            <summary className='flex cursor-pointer list-none items-center justify-between gap-4 rounded-lg text-lg font-semibold text-ink focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring [&::-webkit-details-marker]:hidden'>
                                {faq.question}

                                <span className='grid size-8 shrink-0 place-items-center rounded-full bg-foam text-aqua-deep transition-transform duration-200 group-open:rotate-45'>
                                    <Plus className='size-4' />
                                </span>
                            </summary>

                            <p className='mt-3 pr-10 leading-relaxed text-muted-foreground'>
                                {faq.answer}
                            </p>
                        </details>
                    ))}
                </div>
            </Container>
        </section>
    )
}
